export default "__VITE_ASSET__CmVMo5Ds__"